<template>
  <div>
    <p class="tw-text-2xl tw-mx-2 tw-mt-4 tw-font-semibold">User Dashboard</p>
    <Landing class="tw-mx-2 tw-mb-4 tw-text-white" />
    <v-divider class="tw-mx-2 tw-opacity-50" color="#F08937"></v-divider>
    <div
      class="tw-mx-2 tw-mt-4 tw-block md:tw-flex md:tw-flex-wrap md:tw-justify-between"
    >
      <p class="tw-text-eko-orange tw-text-xl">Your Projects</p>
      <router-link
        to="/lister/projects"
        class="tw-text-eko-dark tw-cursor-pointer"
        >View More</router-link
      >
    </div>
    <div v-if="projects.length > 0" class="tw-flex tw-flex-wrap tw--mt-2">
      <div class="tw-w-full md:tw-w-1/4 tw-p-2">
        <ProjectCard :project="projects[0]" />
      </div>
      <div class="tw-w-full md:tw-w-1/4 tw-p-2">
        <ProjectCard :project="projects[1]" />
      </div>
      <div class="tw-w-full md:tw-w-1/4 tw-p-2">
        <ProjectCard :project="projects[2]" />
      </div>
      <div class="tw-w-full md:tw-w-1/4 tw-p-2">
        <ProjectCard :project="projects[3]" />
      </div>
    </div>
    <div v-else>
      <p>No projects created yet</p>
    </div>
    <v-divider
      class="tw-mx-2 tw-mt-4 tw-opacity-50"
      color="#F08937"
    ></v-divider>
  </div>
</template>

<script>
import Landing from "@/components/Shared/Landing.vue";
import ProjectCard from "@/components/Lister/SingleProject.vue";
import axios from "axios";

export default {
  components: {
    Landing,
    ProjectCard,
  },
  data() {
    return {
      user: {},
      token: "",
      drawer: true,
      admin: null,
      projects: [],
      company: {},
    };
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    this.company = JSON.parse(localStorage.getItem("eko-carbon-company"));
    this.fetchProjects();
  },
  methods: {
    fetchProjects() {
      axios
        .get(`${this.$baseUrl}/project/getAll/${this.company._id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data.project);
          this.projects = response.data.project;
          console.log(this.data);
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data
            ? error.response.data.message
            : "An error occured";
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
